export default "__VITE_ASSET__D1FiHQ8Q__"